<script setup lang="ts">
import type { NavigationMenuItem } from "@nuxt/ui";

const { $auth } = useNuxtApp();

const collapse = ref<boolean>(true);
const warning = ref<boolean>(sessionStorage.getItem("show-warning") ? false : true );

const verticalMenu: NavigationMenuItem[][] = [
  [
    {
      label: "کلاس درس",
      to: { name: "index" },
      icon: "i-solar-music-notes-linear",
    },
    {
      label: "دوره‌های‌من",
      to: { name: "courses" },
      icon: "i-solar-music-library-2-linear",
    },
    {
      label: "پیام‌ها",
      to: { name: "profile-tickets" },
      icon: "i-solar-chat-round-linear",
    },
    {
      label: "پروفایل",
      to: "/profile",
      avatar: {
        src: $auth.user?.avatar ?? '',
        alt: $auth.user
          ? (($auth.user?.firstName + $auth.user?.lastName) as string)
          : "",
        size: 'lg'
      },
    },
  ],
];

const horizontalMenu: NavigationMenuItem[][] = [
  [
    {
      label: "کلاس درس",
      to: { name: "index" },
      icon: "i-solar-music-notes-linear",
    },
    {
      label: "دوره‌های‌من",
      to: { name: "courses" },
      icon: "i-solar-music-library-2-linear",
    },
    {
      label: "پیام‌ها",
      to: { name: "profile-tickets" },
      icon: "i-solar-chat-round-linear",
    },
  ],
];

useHead({
  titleTemplate: (titleChunk) => {
    return titleChunk ? `${titleChunk} | خنیاگر` : "خنیاگر";
  },
  htmlAttrs: {
    lang: "fa-IR",
    dir: "rtl",
  },
  bodyAttrs: {
    class: "bg-neutral-100 dark:bg-neutral-950",
  },
});

const closeWarning =()=>{
  sessionStorage.setItem("show-warning","true");
  warning.value = false;
}
</script>

<template>
  <UApp dir="rtl" :toaster="{ position: 'top-center' }">
    <NuxtLoadingIndicator />

    <UDashboardGroup unit="rem" :persistent="false">
      <UDashboardPanel id="root-panel" class="h-full pb-15 lg:pb-0">
        <UDashboardNavbar
          class="hidden lg:flex lg:px-[10vw] bg-neutral-50 dark:bg-neutral-900"
        >
          <template #left>
            <UNavigationMenu
              :items="horizontalMenu[0]"
              :ui="{
                link: 'rounded-md small hover:bg-primary-500 hover:[&_*]:text-white dark:data-[active]:bg-neutral-900 dark:data-[active]:text-neutral-50! dark:data-[active]:[&_span]:text-neutral-50! dark:text-neutral-300 dark:hover:text-neutral-100 ',
              }"
            />
          </template>

          <template #right>
            <NuxtLink :to="{ name: 'profile' }">
              <UAvatar :width="250" :height="250" :src="$auth.user?.avatar ?? ''" :alt="$auth.user ? (($auth.user?.firstName + $auth.user?.lastName) as string) : 'خ'" size="lg" />
            </NuxtLink>
          </template>
        </UDashboardNavbar>

        <NuxtPage />
      </UDashboardPanel>

      <UDashboardSidebar
        v-model:collapsed="collapse"
        dir="rtl"
        class="bg-neutral-50 dark:bg-neutral-900"
      >
        <template #default="{ collapsed }">
          <UNavigationMenu
            dir="rtl"
            :collapsed
            :items="verticalMenu[0]"
            orientation="horizontal"
            class="w-full p-0 gap-0 m-0 items-center justify-center"
            :ui="{
              root: 'w-full flex flex-1 [&>div]:w-full [&>div]:min-w-0',
              item: 'flex  w-full ',
              link: 'gap-1 flex-col rounded-md small hover:bg-primary-500 hover:[&_*]:text-white dark:data-[active]:bg-neutral-900 dark:data-[active]:text-neutral-50! dark:data-[active]:[&_span]:text-neutral-50! dark:text-neutral-300 dark:hover:text-neutral-100 ',
              linkLabel: 'text-xs ',
            }"
          />
        </template>
      </UDashboardSidebar>
    </UDashboardGroup>
  </UApp>
</template>
